<template>
  <!-- This component doesn't render anything visible -->
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => ['WebPage', 'Product', 'Organization', 'FAQPage'].includes(value)
  },
  data: {
    type: Object,
    required: true
  }
})

// Create the structured data object based on the type
const structuredData = computed(() => {
  const baseData = {
    '@context': 'https://schema.org',
    '@type': props.type,
    ...props.data
  }
  
  return baseData
})

// Add structured data to the page
useHead({
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify(structuredData.value)
    }
  ]
})
</script>
